import { Divider, Typography } from "@/components/atoms";
import { useCountryConfig } from "@/hooks";
import { StripeState } from "@/redux/slices/payment/types";
import { clsx } from "@/utils";
import { renderDetail } from "../helpers";

interface DebitsDetailsProps extends React.HTMLAttributes<HTMLDivElement> {
  debits: StripeState["debits"];
}

export const DebitsDetails = ({ debits, className, ...props }: DebitsDetailsProps) => {
  const { config } = useCountryConfig();
  const routingLabel = config.bankRoutingLabel;
  // A card-only country stores a card here; the backend maps brand → bankName and last4 → accountNumber.
  const isCard = debits.type === "card";

  return (
    <div
      className={clsx("flex flex-col rounded-lg border border-neutral-mid-gray bg-neutral-surface-gray p-5 lg:w-[573px]", className)}
      {...props}
    >
      <Typography variant="action" className="text-neutral-dark-gray">
        {isCard ? "Card" : "Bank Name"}
      </Typography>
      <Typography variant="title" className="mt-1">
        {renderDetail(debits.bankName)}
      </Typography>
      <Divider className="my-3" />
      <div className="grid grid-cols-2">
        {!isCard && (
          <div className="col-span-1">
            <Typography variant="paragraph" className="text-neutral-dark-gray">
              {routingLabel}
            </Typography>
            <Typography variant="paragraph">{renderDetail(debits.routingNumber)}</Typography>
          </div>
        )}
        <div className="col-span-1">
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            {isCard ? "Last 4 digits of card" : "Last 4 digits of account number"}
          </Typography>
          <Typography variant="paragraph">{renderDetail(debits.accountNumber)}</Typography>
        </div>
        <div className="col-span-2 mt-4">
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            {isCard ? "Cardholder name" : "Account holder name"}
          </Typography>
          <Typography variant="paragraph">{renderDetail(debits.accountName)}</Typography>
        </div>
      </div>
    </div>
  );
};
